import React, { FC, useState } from "react"
import xss from "xss"

import { generateConditionalClassName } from "@utils"

import { Icon, ICON_TYPES } from "@helpscout/hs-marketing-shared-components"

import "./Accordion.scss"

export enum ACCORDION_SIZES {
  DEFAULT = "M",
  S = "S",
  M = "M",
  L = "L",
}

interface AccordionProps {
  children: React.ReactNode
  hideCheck?: boolean
  size?: keyof typeof ACCORDION_SIZES
  title: string
}

const Accordion: FC<AccordionProps> = ({
  children,
  hideCheck,
  size = ACCORDION_SIZES.DEFAULT,
  title,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleClickTitle = (e: React.MouseEvent) => {
    e.preventDefault()
    setIsOpen(!isOpen)
  }

  const _accordionClassNames = generateConditionalClassName({
    Accordion: true,
    "has-check": !hideCheck,
    "is-open": isOpen,
    "no-check": !!hideCheck,
    [`size--${size}`]: true,
  })

  const _titleButtonClassNames = generateConditionalClassName({
    "Accordion--title-button": true,
  })

  const _titleClassNames = generateConditionalClassName({
    "Accordion--title-button-h4": true,
    "font-weight--medium": size === ACCORDION_SIZES.L,
    "type--headline-medium-L": size === ACCORDION_SIZES.S,
    "type--headline-medium-XL": ![ACCORDION_SIZES.S, ACCORDION_SIZES.L].includes(size as ACCORDION_SIZES)
  })

  return (
    <div className={_accordionClassNames}>
      <button
        className={_titleButtonClassNames}
        onClick={handleClickTitle}
      >
        <h4
          className={_titleClassNames}
          dangerouslySetInnerHTML={{ __html: xss(title) }}
        />
        <Icon
          size={
            size === ACCORDION_SIZES.L ?
              "24px" :
              "16px"
          }
          type={ICON_TYPES["close"]}
        />
      </button>
      <div className="Accordion--content">
        <div className="content">{children}</div>
      </div>
    </div>
  )
}

export default Accordion
